import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  GcLoadingSpinnerComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { ErrorScreenSigningSummaryComponent } from '../../../../error-screen-signing-summary/error-screen-signing-summary.component';
import { OverlayComponent } from '../../../../overlay/overlay.component';
import { SignatureDataService } from '../../../../signature/service/signature-data/signature-data.service';
import { SignatureService } from '../../../../signature/service/signature.service';
import { SignatureComponent } from '../../../../signature/signature.component';
import {
  QueryLoadingStateSignatureData$,
  SignatureInitVariables,
  SignatureSections,
  SignatureUrlsTypes,
} from '../../../../signature/signature.entities';
import { SigningConfirmationModalComponent } from '../../../../signing/signing-confirmation-modal/signing-confirmation-modal.component';
import { ScreenSizeClassComponent } from '../../../../util/screen-size/screen-size.component';
import { CustomerInformationComponent } from './customer-information/customer-information.component';
import { SelfInspectionsComponent } from './self-inspections/self-inspections.component';
import { SigningLanguageChooserComponent } from './signing-language-chooser/signing-language-chooser/signing-language-chooser.component';

@Component({
  selector: 'app-signing-summary',
  standalone: true,
  imports: [
    CommonModule,
    GcTextComponent,
    IpoTranslatePipe,
    SignatureComponent,
    GcLoadingSpinnerComponent,
    CustomerInformationComponent,
    SelfInspectionsComponent,
    ErrorScreenSigningSummaryComponent,
    OverlayComponent,
    SigningConfirmationModalComponent,
    SigningLanguageChooserComponent,
  ],
  templateUrl: './signing-summary.component.html',
  styleUrl: './signing-summary.component.scss',
})
export class SigningSummaryComponent
  extends ScreenSizeClassComponent
  implements OnInit, OnDestroy
{
  signatureDataService = inject(SignatureDataService);
  router = inject(Router);
  signatureService = inject(SignatureService);

  @Input() ifs?: string;
  @Input() deliveryOrderId?: string;
  @Input() groupAgreementId?: string;
  @Input() sourceId?: string;

  querySigningData$: QueryLoadingStateSignatureData$;
  signingSummaryConfirmationModal =
    this.signatureDataService.signingSummaryConfirmationModal;

  PDFLoadingState = this.signatureDataService.createPdfLoadingState;

  ngOnInit(): void {
    this.setInitVariables();
    this.getSigningData();
  }

  ngOnDestroy(): void {
    this.signatureService.clearInitValues();
  }

  getSigningData = () => {
    const reportId = this.sourceId ?? this.deliveryOrderId;
    if (this.ifs && reportId) {
      this.querySigningData$ = this.signatureDataService.getSigningData$(
        this.signatureService.initValues().urls.signature,
        this.ifs,
        reportId,
        this.signatureService.initValues().section,
      );
    }
  };

  setInitVariables = () => {
    const values: SignatureInitVariables = {
      ifs: this.ifs ? this.ifs : '',
      deliveryOrderId: this.deliveryOrderId ? this.deliveryOrderId : '',
      section: SignatureSections.PLOT_DESIGN,
      urls: {
        file: SignatureUrlsTypes.installationReports.file,
        signature: SignatureUrlsTypes.installationReports.signature,
      },
      ...(this.groupAgreementId && this.sourceId
        ? {
            mduSigningRequest: {
              ifsNumber: this.ifs ?? '',
              groupAgreementId: this.groupAgreementId,
              sourceId: this.sourceId,
              sectionType: SignatureSections.PLOT_DESIGN,
            },
          }
        : {}),
    };

    this.signatureService.setInitValues(values);
  };
}
